module.exports = __webpack_public_path__ + "static/media/contentTesting-01.3c697d49.png";